import { FieldFilterType, IEntity } from "../types";
import { IEntityFilter, IPageLink } from "../models";

import Logger from "../../../helpers/Logger";

export const PageLinkHelper = {
    encodeTableFilters: (filters: IEntityFilter[]) => {
        const encoded = filters.map(filter => `${encodeURI(filter.field)}=${filter.type}(${encodeURI(filter.value)})`);
        return JSON.stringify(encoded);
    },

    getPageLinkUrl: (siteId: string, pageLink: IPageLink) => {
        if (!pageLink)
            return '';

        let filters: string[] = [];
        if (pageLink.filters && pageLink.filters.length > 0)
            filters.push(`filters=${PageLinkHelper.encodeTableFilters(pageLink.filters)}`)

        if (pageLink.pageMode)
            filters.push(`mode=${pageLink.pageMode}`);

        if (pageLink.systemId)
            filters.push(`id=${pageLink.systemId}`)

        return `/site(${siteId})/page(${pageLink.pageId})?${filters.join('&')}`
    },

    resolvePageLink: (pageLink: IPageLink, row: IEntity, pageFilters: IEntityFilter[]) => {
        const filters = PageLinkHelper.resolveFilters(pageLink.filters || [], row, pageFilters);
        let newPageLink = { ...pageLink, filters }
        const systemId = pageLink.systemId ? row[pageLink.systemId] : undefined;
        return { ...newPageLink, systemId } as IPageLink;
    },

    resolveFilters: (filters: IEntityFilter[], data: IEntity, viewFilters: IEntityFilter[]): IEntityFilter[] => {
        return filters.map(filter => {
            if (filter.type !== FieldFilterType.Field)
                return filter;

            // Field value from data
            const value = data[filter.value];
            if (value !== undefined) {
                return { ...filter, type: FieldFilterType.Const, value }
            }

            // Field value from view        
            const viewFilter = viewFilters.find(p => p.field === filter.field)
            if (viewFilter && viewFilter.type === FieldFilterType.Const)
                return { ...filter, type: FieldFilterType.Const, value: viewFilter.value }

            Logger.error(`${filter.field} field value not found in data`, filter);
            throw new Error(`${filter.field} field value not found in data`)
        });
    }
}